document.addEventListener("DOMContentLoaded", () => {
    const loader = document.getElementById("infinite-loader");
    const productGrid = document.getElementById("product-grid");
    let nextUrl = document.querySelector(".pagination .next a")?.href;
    let loading = false;

    if (!productGrid) return;

    window.addEventListener("scroll", () => {
        if (loading || !nextUrl) return;

        if (window.scrollY + window.innerHeight >= document.body.offsetHeight - 400) {
            loading = true;
            loader.style.display = "block";

            fetch(nextUrl)
                .then(res => res.text())
                .then(data => {
                    const parser = new DOMParser();
                    const htmlDoc = parser.parseFromString(data, "text/html");

                    const newItems = htmlDoc.querySelectorAll("#product-grid li");
                    newItems.forEach(item => productGrid.appendChild(item));

                    nextUrl = htmlDoc.querySelector(".pagination .next a")?.href || null;

                    loader.style.display = "none";
                    loading = false;
                })
                .catch(() => {
                    loader.style.display = "none";
                });
        }
    });
});
